import React from "react";
import StickyNote from "../StickyNote";

const Top3ValuesBoard = ({ values, onValueClick }) => {
  // Nut Component
  const Nut = () => {
    return (
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: 12.075,
            height: 12.073,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "50%",
            background: "radial-gradient(circle at 30% 30%, #FFFFFF 0%, #F3F3F3 10%, #D3D3D3 30%, #A0A0A0 50%, #7D7D7D 60%, #373737 70%, #1D1D1D 80%, #AAAAAA 90%, #C8C8C8 100%)",
            boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.3)",
          }}
        >
          <div
            style={{
              position: "absolute",
              width: 11.43,
              height: 8.095,
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(-45deg)",
              background: "linear-gradient(139.8deg, #050505 38.05%, #0F0F0F 40.28%, #191919 44.74%, #1D1D1D 51.43%)",
              borderRadius: 2,
              opacity: 0.6,
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="relative">
      {/* Glassmorphic Board */}
      <div
        style={{
          width: 399,
          height: 526,
          borderRadius: 20,
          background: "linear-gradient(142.13deg, rgba(255, 255, 255, 0.116) 1.8%, rgba(255, 255, 255, 0.132) 99.75%)",
          border: "10px solid transparent",
          borderImage: "linear-gradient(143.48deg, rgba(255, 255, 255, 0.43) 9.15%, rgba(227, 227, 227, 0.41) 112.98%) 1",
          backdropFilter: "blur(130px)",
          boxShadow: "0px 4px 15.8px 0px rgba(0, 0, 0, 0.25)",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        {/* Corner Nuts */}
        <div style={{ position: "absolute", top: 20, left: 20, width: 20.3, height: 20 }}>
          <Nut />
        </div>
        <div style={{ position: "absolute", top: 20, right: 20, width: 20.3, height: 20 }}>
          <Nut />
        </div>
        <div style={{ position: "absolute", bottom: 20, left: 20, width: 20.3, height: 20 }}>
          <Nut />
        </div>
        <div style={{ position: "absolute", bottom: 20, right: 20, width: 20.3, height: 20 }}>
          <Nut />
        </div>

        {/* Title */}
        <h3
          style={{
            fontFamily: "Gotham",
            fontWeight: 700,
            fontSize: 21,
            lineHeight: "100%",
            letterSpacing: "0%",
            textAlign: "center",
            textTransform: "uppercase",
            color: "#323232",
            marginTop: 40,
            marginBottom: 20,
            zIndex: 10,
          }}
        >
          My Top 3 Values
        </h3>

        {/* Gradient Ellipse with Fog Effect - ALWAYS VISIBLE */}
        <div
          style={{
            position: "absolute",
            bottom: 50,
            left: "50%",
            transform: "translateX(-50%)",
            width: 213,
            height: 213,
            background: "radial-gradient(circle, #54B0AF 0%, rgba(84, 176, 175, 0.8) 40%, rgba(84, 176, 175, 0.4) 70%, transparent 100%)",
            backdropFilter: "blur(200px)",
            WebkitBackdropFilter: "blur(200px)",
            borderRadius: "50%",
            filter: "blur(40px)",
            opacity: 0.9,
            zIndex: 1,
          }}
        />

        {/* Sticky Notes Container */}
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 20,
            marginTop: 30,
            paddingBottom: 60,
            zIndex: 10,
          }}
        >
          {/* Only show sticky notes when values exist - NO PLACEHOLDERS */}
          {values.map((value, index) => (
            <div
              key={`${value}-${index}`}
              style={{
                position: "relative",
                width: 120,
                minHeight: 110,
              }}
            >
              <StickyNote
                text={value}
                style={{
                  position: "relative",
                  top: 0,
                  left: 0,
                }}
                colorIndex={index}
                rotation={0}
                onClick={() => onValueClick?.(value)}
              />

              {/* Number Badge */}
              <div
                style={{
                  position: "absolute",
                  bottom: -5,
                  left: "43%",
                  transform: "translateX(-50%)",
                  width: 29.25,
                  height: 29.25,
                  borderRadius: "50%",
                  background: "#000000",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 50,
                  pointerEvents: "none",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)",
                }}
              >
                <span
                  style={{
                    fontFamily: "Gotham",
                    fontWeight: 700,
                    fontSize: 16,
                    color: "#FFFFFF",
                    lineHeight: 1,
                  }}
                >
                  {index + 1}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Top3ValuesBoard;
